import { HtmlComponent } from './../../html-component';

// import html
import template from './map-button.hogan.html';

export class MapPulseButton extends HtmlComponent {
    constructor(private pulseCallback: any, text: string, icon: string) {
        super(template, { text, icon });
        this.jqueryElement.click(this.pulse);
    }

    private pulse = () => {
        this.pulseCallback();
        this.jqueryElement.addClass('active');
        this.jqueryElement.removeClass('inactive');
        setTimeout(() => {
            this.jqueryElement.addClass('inactive');
            this.jqueryElement.removeClass('active');
        }, 500);
    }
}
